import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

interface ICreatePricingCategoryBody {
  name: string;
  parent_category_id: string | null;
}

export const createPricingCategory = async (
  priceSchemeId: string,
  body: ICreatePricingCategoryBody[],
): Promise<void> => {
  const url = `${API_URL}/pricing/schemes/${priceSchemeId}/categories`;
  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({ categories: body }),
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) {
    throw new Error('Unable to create pricing category');
  }
};
